import gql from 'graphql-tag';

export const GET_JOB_DETAILS = gql`
  query($id: ID!) {
    weployer {
      job(id: $id) {
        id
        belongsToCurrentUser
        createdAt
        dressCode
        experience
        isTransferrable
        isRemote
        latestPositionFinishTime
        meetingInstructions
        numberOfPositions
        owner
        paymentMethod
        primarySkill
        status
        startTime
        tasks
        timeRequirements
        title
        location {
          street
          city
          postcode
          state
        }
      }
    }
  }
`;

export const GET_JOB_POSITIONS_AND_WEPLOYEES = gql`
  query($id: ID!) {
    weployer {
      job(id: $id) {
        id
        belongsToCurrentUser
        positions {
          id
          status
          startTime
          finishTime
          extendable
          isCancellable
          isFinishingSoon
          hasPendingExtensionRequests
          latestApprovedTimesheetId
          latestTimesheetId
          weployee {
            id
            contactDetails {
              email
              name
              phoneNumber
            }
            profileImageUrl
          }
          timesheets {
            id
            lastEntryDate,
            firstEntryDate,
          }
        }
      }
    }
  }
`;

export const CREDIT_CARD = 'CREDIT_CARD';
export const INVOICE = 'INVOICE';
export const TIMESHEET_AWAITING_APPROVAL = 'TIMESHEET_AWAITING_APPROVAL';
